export default __webpack_public_path__ + "static/TSD_How_we_work_hero-1ed5b190d2e3ec4e16ec35894da3dcd4.png";